import { useStaticQuery, graphql } from 'gatsby'

export const useSiteMetadata = () => {
    const { site } = useStaticQuery(
        graphql`
            query SiteMetaData {
                site {
                    siteMetadata {
                        languages {
                            defaultLangKey
                            langs
                        }
                        siteUrl
                        siteTitle
                    }
                }
            }
        `
    )

    return site.siteMetadata
}
